export const APP_CONFIG = __APP_CONFIG__;
export const APIBASE = APP_CONFIG.apiBase;
export const SOCKET_SERVER = APP_CONFIG.socketServer;
export const SITE = APP_CONFIG.site;
export const ENV = APP_CONFIG.environment;
// The develop/staging environment is built with ENV=test. There, auth emails
// (invitation, password-reset, 2FA) are delivered to their real recipient, so
// we warn when inviting users. This mirrors checkpoint's SEND_REAL_AUTH_EMAILS
// flag, which actually controls delivery — the two must be set together.
export const IS_DEVELOP = ENV === 'test';
//# sourceMappingURL=config.js.map